/*
  Auto shipping protection (Auralore)
  Pre-selects the cart drawer's Shipping Protection toggle once the cart has
  a real product in it. Uses the theme's own toggle, so adding/removing and
  the drawer refresh are handled by the theme. If the customer switches it
  off, it stays off for the rest of their visit. If the cart ends up holding
  only the protection item, it is removed.
*/
(function () {
  var OPT_OUT_KEY = 'auralore_sp_opt_out';
  var busy = false;

  function optedOut() {
    try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut() {
    try { sessionStorage.setItem(OPT_OUT_KEY, '1'); } catch (e) {}
  }

  function spId() {
    return typeof shippingProductId !== 'undefined' ? String(shippingProductId) : '';
  }

  function cartLines() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return [];
    return Array.prototype.slice.call(drawer.querySelectorAll('cart-remove-button[data-id]'));
  }

  function check() {
    if (busy) return;
    var id = spId();
    var toggle = document.querySelector('.gb-shipping-protection-button label.switch');
    if (!id || !toggle) return;

    var lines = cartLines();
    var hasProtection = lines.some(function (b) { return b.dataset.id === id; });
    var otherItems = lines.filter(function (b) { return b.dataset.id !== id; }).length;

    if (otherItems > 0 && !hasProtection && toggle.classList.contains('unchecked') && !optedOut()) {
      busy = true;
      toggle.click();
      setTimeout(function () { busy = false; }, 2500);
    } else if (otherItems === 0 && hasProtection && toggle.classList.contains('checked')) {
      busy = true;
      toggle.click();
      setTimeout(function () { busy = false; }, 2500);
    }
  }

  // Remember when the customer turns protection off themselves.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.gb-shipping-protection-button label.switch');
    if (toggle && e.isTrusted && toggle.classList.contains('checked')) setOptOut();
    var remove = e.target.closest && e.target.closest('cart-remove-button[data-id]');
    if (remove && e.isTrusted && remove.dataset.id === spId()) setOptOut();
  }, true);

  function start() {
    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(check, 400);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(check, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
